import { render } from "./HomeView.vue?vue&type=template&id=51a2cd34&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=51a2cd34&lang=css"

import exportComponent from "/home/runner/work/PIPIPIG233666.github.io/PIPIPIG233666.github.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__